export const INVITEE_STATUS = {
  AUTO_ENROLLED: 'auto_enrolled',
  ALREADY_ENROLLED: 'already_enrolled',
  PENDING_ENROLLED: 'pending_enrolled',
  UNPROCESSED: 'unprocessed',
  UNTOUCHED: 'untouched',
};
